module.exports = __webpack_public_path__ + "static/image22-36dc2a8767ebc076baa2022b2cf35336.jpg";